export const AVAILABLE_SLOTS_ERRORS = {
  CATCH_ERROR: {
    code: 'ERR_BOOKING_PARTNER_INTEGRATIONS_CATCH_ERROR',
  },
  INSUFFICIENT_CAPACITY: {
    code: 'ERR_BOOKING_AVAILABLE_SLOTS_NOT_ENOUGH_CAPACITY',
  },
  PARTNER_ALLOWED_TIMES: {
    code: 'ERR_INVALID_COMPLIANCE_WITH_PARTNER',
  },
  RESPONSE_IS_EMPTY: {
    code: 'ERR_BOOKING_AVAILABLE_SLOTS_RESPONSE_IS_EMPTY',
  },
  VALIDATION_ERROR: {
    code: 'ERR_BOOKING_PARTNER_INTEGRATIONS_VALIDATION_ERROR',
  },
};
